<template>
  <div>
    <div ref="projects">
      <template v-if="!!content">
        <ProjectsSwiper
          :content="content"
          @handleSlideChange="handleSlideChange"
          @handleTransition="handleTransition"
        />

        <ProjectsProgressCircle
          :transition="transition"
          class="fixed z-10 right-0 bottom-0 m-3"
        />
      </template>
    </div>
    <template v-if="!!content">
      <div class="fixed bottom-0 z-10 pb-2 pl-3 pt-4 filter">
        <span class="select-none text-mobile lg:text-laptop 2xl:text-copy"
          >↳ {{ content[realIndex].fields.title }}</span
        >
      </div>
      <!-- <ProjectsIndexCursor
        :elm="$refs.projects"
        :realIndex="realIndex"
        :totalIndex="content.length"
      /> -->
    </template>
  </div>
</template>

<script>
import { getProjects } from "@/utils/IO";
import ProjectsSwiper from "./ProjectsSwiper";
import ProjectsProgressCircle from "./ProjectsProgressCircle";
// import ProjectsIndexCursor from "./ProjectsIndexCursor";

export default {
  name: "Projects",

  components: {
    ProjectsSwiper,
    ProjectsProgressCircle
    // ProjectsIndexCursor
  },

  data: () => ({
    content: null,
    realIndex: 0,
    transition: false
  }),

  async created() {
    this.content = await getProjects();

    this.$store.commit("setTotalIndex", this.content.length);
  },

  methods: {
    handleSlideChange(realIndex) {
      this.realIndex = realIndex;
      this.$store.commit("setRealIndex", realIndex);
      this.$store.commit(
        "setForgroundColor",
        this.content[realIndex].fields.foregroundColor
      );
    },
    handleTransition(val) {
      this.transition = val;
    }
  }
};
</script>
